module.exports = __webpack_public_path__ + "img/yd-dg-img.8fc9cb23.jpg";